import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useCallSessionRoomStore } from '@/entities/call-session'

import { STATE, useWebRTC } from '@/shared/services/jssip'
import { getChatRoute } from '@/shared/utils/url'

const isAnsweredSessionState = (state: STATE) => state === STATE.CONNECTED || state === STATE.ONHOLD

export const callSessionBeforeEnter = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  const { sessionId } = to.params

  if (!sessionId) {
    next({ name: 'Main' })
  } else if (typeof sessionId === 'string') {
    const { getRTCSessionFacadeById } = useWebRTC()
    const facade = getRTCSessionFacadeById(sessionId)

    if (!facade) {
      next({ name: 'Main' })
      return
    }

    if (!isAnsweredSessionState(facade.sessionState.value)) {
      const room = useCallSessionRoomStore().getRoom(sessionId)
      const chatRoute = room ? getChatRoute(room) : null
      next(chatRoute ?? { name: 'Main' })
      return
    }

    next()
  }
}
